import { Wifi, WifiOff } from 'lucide-react'
import { useWebSocketContext } from '@contexts/WebSocketContext'

/**
 * WebSocket Connection Health Indicator
 * Shows a small dot + tooltip in the header indicating WS connection status
 */
export default function WsHealthIndicator() {
  let status = 'disconnected'
  let color = 'bg-gray-400'
  let label = 'Disconnected'

  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isConnected, isAuthenticated, error } = useWebSocketContext()
    if (error) {
      status = 'error'
      color = 'bg-red-500'
      label = `Error: ${error}`
    } else if (isConnected && isAuthenticated) {
      status = 'connected'
      color = 'bg-green-500'
      label = 'Connected'
    } else if (isConnected) {
      status = 'connecting'
      color = 'bg-yellow-500'
      label = 'Authenticating...'
    }
  } catch {
    // Outside WebSocketProvider — show disconnected
  }

  const Icon = status === 'connected' ? Wifi : WifiOff

  return (
    <div className="relative group flex items-center" aria-label={`WebSocket: ${label}`}>
      <Icon className={`w-4 h-4 ${status === 'connected' ? 'text-green-500' : status === 'error' ? 'text-red-500' : 'text-gray-400'}`} />
      <span className={`ml-1 w-2 h-2 rounded-full ${color} ${status === 'connecting' ? 'animate-pulse' : ''}`} />
      <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2 py-1 text-xs rounded bg-gray-900 text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
        WS: {label}
      </span>
    </div>
  )
}
